import * as yup from 'yup'

export default yup.object().shape({
  building_id: yup.string().required('O campo Bloco é requerido.'),
  unitsName: yup.array().min(1, 'O campo Unidade é requerido.')
})
